module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_27.47c7286c.pdf";